import React from 'react';
import BarChart from './charts/bar_chart'
import AppComponent from './app_component'

class TrainingComplianceCharts extends AppComponent {
  constructor(props){
    super(props);

    this.state = {
      currentId: 'average_ratings',
      all_charts: [],
      field_charts: [],
      other_charts: [],
      emergency_charts: [],
      overall_charts: [],
      trainingModulesList: [],
      loading: false,
      rendered_compliance_ratings: []
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.props.complianceRatings !== nextProps.complianceRatings) {
      if(this.state.currentId === 'average_ratings') {
        this.renderAverageRatingsCharts(nextProps);
      } 
      else {
        this.renderCategorizedRatingsCharts(nextProps);
      }

    }

  }

  renderAverageRatingsCharts = (props) => {
    var rendered_compliance_ratings = []
    var categories = ['overall', 'all', 'field', 'other', 'emergency']
    var category_compliance_ratings = {}
    var category

    for(var index in categories) {
      category = categories[index]
      category_compliance_ratings = props.complianceRatings[category]
      if(category_compliance_ratings.ratings.length > 0) {
        rendered_compliance_ratings.push(
          <div className="col-sm-6" key={ 'modules_' + category }>
            <BarChart key={ 'modules_' + category } name={ 'modules-compliance-' + category } data={ category_compliance_ratings.ratings } width={ 520 } height={ 500 } label={ category_compliance_ratings.label }/>
          </div>
        )
      }
    }

    this.setState({ rendered_compliance_ratings, loading: false })
  }

  renderCategorizedRatingsCharts = (props) => {
    var rendered_compliance_ratings = []
    var category_compliance_ratings
    for(var index in props.complianceRatings) {
      category_compliance_ratings = props.complianceRatings[index]
      if(category_compliance_ratings.ratings.length > 0) {
        rendered_compliance_ratings.push(
          <div className="col-sm-6" key={ 'modules_' + index }>
            <BarChart key={ 'modules_' + index } name={ 'modules-compliance-' + index } data={ category_compliance_ratings.ratings } width={ 520 } height={ 500 } label={ category_compliance_ratings.label }/>
          </div>
        )
      }
    }

    this.setState({ rendered_compliance_ratings, loading: false })
  }


  renderQuickNavigation = () => {
    var items = [
      {
        id: 'average_ratings',
        label: 'Compliance Ratings',
        event: (evt) => this.switchView('average_ratings')
      },
      {
        id: 'all',
        label: 'All Staff Compliances',
        event: (evt) => this.switchView('all')
      },
      {
        id: 'other',
        label: 'Team Specific Compliances',
        event: (evt) => this.switchView('other')
      }
    ]

    return (
      <div id="quick-navigation" className='quick-navigation'>
        <span>
          <div className='quick-navigation-label'>Go to: </div>
          {
            items.map((item, index)=>{
              return <div key={index} className={this.state.currentId === item.id ? 'item active' : 'item'} onClick={item.event}><u>{item.label}</u></div>
            })
          }
        </span>
      </div>
    )
  }

  switchView = (id) => {
    this.setState({currentId: id, loading: true});
    this.props.setView(id)
    document.getElementById("charts-content").scrollTop = 0;
  }

  render() {
    const { loading, rendered_compliance_ratings } = this.state
    
    return (
      <div id="charts-content" className="dashboard-content">
        { this.renderQuickNavigation() }
        {
          !loading &&
          <div className='row'>
            { rendered_compliance_ratings.length > 0 && rendered_compliance_ratings }
          </div>
        }
        {
          (this.props.loading || loading) && 
          <div className="loading-message">
            <i className="loading circle notched icon"></i>
            <span>Loading dashboards...</span>
          </div>
        }
      </div>

    )
  }
}

export default TrainingComplianceCharts;



// WEBPACK FOOTER //
// ./src/views/components/v2_training_compliance_charts.js